export default __webpack_public_path__ + "static/media/apache-rr-moto.565e6807.png";